@if (info && (platform$ | async); as platform) {
  <div class="information-card">
    <div class="information-card__description">
      @if (info.name) {
        <app-text
          [textSize]="TextSizes.h1Header"
          [textType]="TextType.base"
          [text]="info.name"
          class="information-card__title"
        ></app-text>
      }
      @if (info.description.city && info.description.house) {
        <div #location class="flex">
          <app-image [img]="locationImgSrc"></app-image>
          <app-text
            [textSize]="TextSizes.mobInput"
            [textType]="TextType.base"
            [text]="[info.description.city.name, info.description.house].join(' ')"
          ></app-text>
        </div>
      }
      @if (info.description.phone && platform === currentPlatform.desktop) {
        <div class="flex">
          <svg-icon [src]="phoneNumberImgSrc" [class]="'information-card__icon'"></svg-icon>
          <app-text
            [textSize]="TextSizes.mobInput"
            [textType]="TextType.base"
            [text]="info.description.phone | phoneNumber"
          ></app-text>
        </div>
      }
      @if (info.description.phone && platform !== currentPlatform.desktop) {
        <a #phone href="tel:+{{ info.description.phone }}" class="flex">
          <svg-icon [src]="phoneNumberImgSrc" [class]="'information-card__icon'"></svg-icon>
          <app-text
            [textSize]="TextSizes.mobInput"
            [textType]="TextType.base"
            [text]="info.description.phone | phoneNumber"
          ></app-text>
        </a>
      }
      @if (info.description.email) {
        <a #email href="mailto:{{ info.description.email }}" class="flex">
          <app-image [img]="emailImgSrc"></app-image>
          <app-text
            class="text-email"
            [textSize]="TextSizes.mobInput"
            [textType]="TextType.base"
            [text]="info.description.email"
          ></app-text>
        </a>
      }
      @if (info.description.numOfEmployees) {
        <app-text
          class="text-light-grey"
          [textSize]="TextSizes.h3Body"
          [textType]="TextType.base"
          [text]="info.description.numOfEmployees | wordDeclension: employeesDeclension"
        ></app-text>
      }
      <div #description>
        @if (info.description.description) {
          <app-text
            class="text-description"
            [textSize]="TextSizes.h3Body"
            [textType]="TextType.base"
            [text]="info.description.description"
          ></app-text>
        }
      </div>
    </div>
  </div>
}
